// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"19dd355e","78":"0a590fe3","130":"4de76ca3","210":"057ba2da","498":"a4dc6228","513":"7528cf3f","583":"6c3cd92d","587":"6c6715a3","636":"36932102","703":"6e207813","910":"7f30ed56"}[chunkId] + ".chunk.js";
};